<template>
  <div class="list-regist">
    <v-container v-if="loadding">
      <v-row justify="center" align="center">
        <v-col>
          <center>
            <h3>กำลังโหลดข้อมูล</h3>
            <p></p>
            <v-progress-circular
              :size="70"
              :width="5"
              color="success"
              indeterminate
            ></v-progress-circular>
          </center>
        </v-col>
      </v-row>
    </v-container>
    <v-lazy
      v-else
      v-model="isActive"
      :options="{
        threshold: 0.5,
      }"
      min-height="100"
      transition="fade-transition"
    >
      <v-container class="contain-list">
        <v-row>
          <v-col
            ><center>
              <p class="head-card" style="font-size: 30px">
                ประกาศจัดซื้อจัดจ้าง
              </p>
              <hr />
              <p class="head-card" style="font-size: 20px">
                วันที่ {{ getDate }} เวลา {{ getaround }} น.
              </p>
            </center></v-col
          >
        </v-row>
        <v-row
          v-for="(item, i) in items"
          :key="i"
          class="ml-2 mr-2 pr-3 pl-3"
          style="
            background-color: #ffffff;
            border-radius: 5px;
            margin-bottom: 10px;
          "
          @click="showdata_head(item.head_id, item.job_type_id_tor)"
        >
          <v-col class="pt-0 pb-0">
            <v-row>
              <v-col class="text-left" style="margin: auto">
                <b style="font-size: 18px; margin: auto">{{
                  item.job_type_name
                }}</b>
              </v-col>
              <v-col
                class="text-right"
                style="margin: auto"
                cols="2"
                lg="2"
                md="2"
                sm="2"
              >
                <b style="font-size: 40px; color: #ffc400; margin: auto">|</b>
              </v-col>
              <v-col
                class="text-right"
                style="margin: auto"
                cols="4"
                lg="4"
                md="4"
                sm="4"
              >
                <b style="font-size: 18px; margin: auto"
                  >{{ item.count_type }} งาน</b
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          class="mt-10 ml-2 mr-2 pr-3 pl-3"
          style="
            background-color: #ffffff;
            border-radius: 5px;
            margin-bottom: 10px;
          "
          @click="openKanpramool()"
        >
          <v-col class="text-center">
            <v-row>
              <v-col class="text-center" style="margin: auto">
                <b style="font-size: 18px; margin: auto">ดูประกาศงานทั้งหมด</b>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-lazy>
  </div>
</template>

<script>
export default {
  name: "showInformationCustomer",
  data: () => ({
    IP: null,
    job_type_name: "",
    head_id: null,
    getDate: "",
    getHours: "",
    getaround: "",
    items: [],
    pop: [],
    loadding: true,
    isActive: false,
  }),
  mounted() {
    this.$axios
      .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
      .then((res) => {
        if (
          !(res.data.response[0].last_version === this.version.split(" ")[3])
        ) {
          setTimeout(() => location.reload(), 2000);
        } else {
          this.$axios.get("https://api.db-ip.com/v2/free/self").then((res) => {
            if (
              res.data.ipAddress === undefined ||
              res.data.ipAddress === null ||
              res.data.ipAddress === ""
            ) {
              location.reload();
            } else {
              let ip = res.data.ipAddress;
              this.getDate =
                new Date().getDate() +
                "/" +
                (new Date().getMonth() + 1) +
                "/" +
                (new Date().getFullYear() + 543) +
                "\n";
              this.getHours =
                new Date().getHours() +
                ":" +
                new Date().getMinutes() +
                ":" +
                new Date().getSeconds();
              if (this.getHours <= "17:00:00") {
                this.getaround = "12:00";
              } else {
                this.getaround = "17:00";
              }
              let head = this.$route.params.id.split("_")[0];
              let token = this.$route.params.id.split("_")[1];
              this.$axios
                .post(this.api + "/get/pop", {
                  head_id: head,
                  token_id: token,
                })
                .then((res) => {
                  this.loadding = false;
                  if (res.data.status) {
                    if (
                      "110.77.145.181" !== ip &&
                      "183.88.221.160" !== ip &&
                      "110.77.145.175" !== ip
                    ) {
                      this.$axios
                        .post("https://ipapi.co/" + ip + "/json/")
                        .then((ress) => {
                          let notify =
                            ress.data.country_name + "| IP: " + ip + ")";
                          this.$axios.post(this.api + "/notifyLogin", {
                            username: notify,
                            login_type: "AccessTorAlert",
                          });
                        })
                        .then(() => {});
                    }
                    this.items = res.data.response;
                  } else {
                    console.log("ไม่สามารถเรียกข้อมูลได้");
                  }
                });
            }
          });
        }
      });
  },
  methods: {
    openKanpramool() {
      window.open("https://www.kanpramool.com", "_BLANK");
    },
    showdata_head(head_id, job_type_id_tor) {
      this.$router.push(
        "/listproject/" +
          head_id +
          "_" +
          this.$route.params.id.split("_")[1] +
          "_" +
          job_type_id_tor
      );
    },
  },
};
</script>

<style>
.head-card {
  color: #ffffff !important;
}
.contain-list {
  background: linear-gradient(to bottom, #062e5d, #34547b 50%, #c5d3e4 100%);
}
</style>
